import api from "../api";

const base = "/v1/rentals/bookings";

export default {
  listReservations: async (params = {}) => {
    const res = await api.get(base, { params });
    return res.data;
  },
  getReservation: async (id) => {
    const res = await api.get(`${base}/${id}`);
    return res.data;
  },
  createReservation: async (payload) => {
    const res = await api.post(base, payload);
    return res.data;
  },
  cancelReservation: async (id) => {
    const res = await api.post(`${base}/${id}/cancel`);
    return res.data;
  },
};
